export default __webpack_public_path__ + "static/media/desc-bg.1afc8fe7.svg";